import React from "react";
import Image from "next/image";
import * as Router from "next/router";
import styled from "styled-components";

import * as u from "../utils";
import * as gtag from "../utils/gtag";
import Fade from "../components/FadeTransition";
import * as T from "./Typography";
import * as I from "../components/Icons";
import Link from "../components/Link";

export default function EventVideoCard(props) {
  const router = Router.useRouter();

  return (
    <Fade disable={props.index < (props.initialListSize || 4)}>
      <Link href={`/events/${props.id}`}>
        <S.EventContainer
          data-cy={`event-video-card--${props.id}`}
          onClick={onClick}
        >
          <S.ImageWrapper>
            <Image
              src={props.cardImage}
              alt={"Watch " + props.title}
              height="223"
              width="223"
              objectFit="cover"
            />
            <S.PlayIconWrapper>
              <I.Play />
            </S.PlayIconWrapper>
          </S.ImageWrapper>
          <S.Wrapper>
            <T.H4 opacity={1}>{props.title}</T.H4>
            {props.showLock && !props.isFree && <S.Lock />}
          </S.Wrapper>
        </S.EventContainer>
      </Link>
    </Fade>
  );

  function onClick() {
    gtag.event({
      name: gtag.GA_EVENT.EVENT_ENGAGEMENT,
      category: "Events",
      label: `Event video`,
      value: router.route,
    });
  }
}

const S = {};

S.EventContainer = styled.div`
  background: white;
  border-radius: 3px;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
  cursor: pointer;
  display: flex;
  transition: all 0.6s cubic-bezier(0.165, 0.84, 0.44, 1);
  &::after {
    border-radius: 5px;
    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);
    content: "";
    height: 100%;
    left: 0;
    opacity: 0;
    position: absolute;
    top: 0;
    transition: all 0.6s cubic-bezier(0.165, 0.84, 0.44, 1);
    width: 100%;
    z-index: -1;
  }
  &:hover {
    transform: scale(1.01, 1.01);
  }
  &:hover::after {
    opacity: 1;
  }
`;

S.Wrapper = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  height: 130px;
  justify-content: space-between;
  overflow: hidden;
  padding: 15px 10px 10px;
  @media ${u.device.tablet} {
    padding: 15px 10px 20px;
  }
  @media ${u.device.desktop} {
    padding: 15px 20px 20px;
    height: 223px;
  }
`;

S.ImageWrapper = styled.div`
  align-items: center;
  border-radius: 3px 0 0 3px;
  display: flex;
  height: 130px;
  justify-content: center;
  overflow: hidden;
  position: relative;
  width: 130px;
  @media ${u.device.desktop} {
    width: 223px;
    height: 223px;
  }
`;

S.PlayIconWrapper = styled.div`
  position: absolute;
`;

S.Lock = styled(I.Lock)`
  color: ${u.colours.charcoal};
  height: 18px;
  width: 14px;
  align-self: flex-end;
`;
